import api from "../api";
import business_id from "../business"
import { toast } from 'vue3-toastify'


export default {
    namespaced: true,
    state: {
        cities: {},
        states: {},
        address: {},
        addresses: {},
        addressStoreNull: {},
        addressDefaultStore: {},
        addressDefault: {},
        addressCompany: {}
    },
    getters: {

    },
    actions: {

        async create({ dispatch, commit }, payload=[]) {
            try {
                api.post(`/v1/address`, payload)
                    .then((res) => {
                        commit("GET_ADDRESS_STORE_NULL", res.data);
                        //dispatch("alert/set_alert", {alert_message: "Salvo com sucesso", type_message: 'alert-success'}, { root: true });
                    
                        //if (window.innerWidth < 480) {
                            toast.success("Salvo com sucesso", {
                              type: 'default',
                              theme: 'colored',
                              hideProgressBar: true,
                              dangerouslyHTMLString: true
                            });
                        //}
                    })
                    .catch((error) => {
                        commit("ERROR_STATE", "Erro ao carregar os enderecos");
                        //dispatch("alert/set_alert", {alert_message: "Algo deu errado", type_message: 'alert-danger'}, { root: true });
                    
                        //if (window.innerWidth < 480) {
                            setTimeout(() => {
                              toast.warning("Erro ao criar o endereço", {
                                type: 'default',
                                theme: 'colored',
                                hideProgressBar: true,
                                dangerouslyHTMLString: true
                              });
                            }, 100);
                        //}
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_STATE", e);
            }
        },

        async update({ dispatch, commit }, payload) {
            try {
              api.post("/v1/update-address/", payload)
                .then((res) => {
                  commit("GET_UPT_ADDRESS", res?.data);
                  //dispatch("alert/set_alert", {alert_message: "Salvo com sucesso", type_message: 'alert-success'}, { root: true });

                  //if (window.innerWidth < 480) {
                    toast.success("Salvo com sucesso", {
                      type: 'default',
                      theme: 'colored',
                      hideProgressBar: true,
                      dangerouslyHTMLString: true
                    });
                //}
                  //location.reload();
                })
                .catch((error) => {
                  commit("ERROR_UPT_ADDRESS", error);
                  //dispatch("alert/set_alert", {alert_message: "Algo deu errado", type_message: 'alert-danger'}, { root: true });

                  //if (window.innerWidth < 480) {
                    setTimeout(() => {
                      toast.warning("Algo deu errado", {
                        type: 'default',
                        theme: 'colored',
                        hideProgressBar: true,
                        dangerouslyHTMLString: true
                      });
                    }, 100);
                  //}
                })
                .finally(() => (
                  // this.loading = false
                  console.log('login request end')
                ));
            } catch (e) {
              commit("ERROR_UPT_ADDRESS", e);
              //dispatch("alert/set_alert", {alert_message: "Algo deu errado", type_message: 'alert-danger'}, { root: true });

              //if (window.innerWidth < 480) {
                toast.error("Algo deu errado", {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}
            }
          },

        async get_address({ commit }) {
            try {
                api.get(`/v1/address`)
                    .then((res) => {
                        commit("GET_ADDRESS", res.data);
                        console.log(response.res);
                    })
                    .catch((error) => {
                        commit("ERROR_STATE", "Erro ao carregar os enderecos");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_STATE", e);
            }
        },

        async add_address({ commit }, payload = []) {
            try {
                const res = await api.post(`/v1/address/add_address`, payload)
                    .then((res) => {
                        commit("GET_ADD_ADDRESS", res.data);
                        console.log(response.res);
                        return res;
                    })
                    .catch((error) => {
                        commit("ERROR_ADD_ADDRESS", "Erro ao carregar os enderecos");
                        throw error
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_ADD_ADDRESS", e);
            }
        },

        async get_states({ commit }) {
            try {
                api.get(`/v1/states`)
                    .then((res) => {
                        commit("GET_STATES", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_STATE", "Erro ao carregar as states");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_STATE", e);
            }
        },

        async get_cities({ commit }, payload) {
            try {
                api.get(`/v1/cities/state/${payload}`)
                    .then((res) => {
                        commit("GET_CITIES", res.data);
                    })
                    .catch((error) => {
                        commit("ERROR_CITY", "Erro ao carregar as cities");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_CITY", e);
            }
        },

        async get_address_null_store({ commit }) {
            try {
                api.get(`/v1/address-store-null`)
                    .then((res) => {
                        commit("GET_ADDRESS_STORE_NULL", res.data);
                        console.log(response.res);
                    })
                    .catch((error) => {
                        commit("ERROR_STORE_NULL", "Erro ao carregar os enderecos");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_STORE_NULL", e);
            }
        },

        async get_address_default_store({ commit }, store_id) {
            try {
                api.get(`/v1/address-default-store/${store_id}`)
                    .then((res) => {
                        commit("GET_ADDRESS_DEFAULT_STORE", res.data);
                        console.log(response.res);
                    })
                    .catch((error) => {
                        commit("ERROR_DEFAULT_STORE", "Erro ao carregar os enderecos");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_DEFAULT_STORE", e);
            }
        },

        async get_address_company({ commit }, company_id) {
            try {
                api.get(`/v1/address-company/${company_id}`)
                    .then((res) => {
                        commit("GET_ADDRESS_COMPANY", res.data);
                        console.log(response.res);
                    })
                    .catch((error) => {
                        commit("ERROR_ADDRESS_COMPANY", "Erro ao carregar os enderecos");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_ADDRESS_COMPANY", e);
            }
        },

        async get_address_default({ dispatch, commit }) {
            try {
                api.get(`/v1/address-default`)
                    .then((res) => {
                        commit("GET_ADDRESS_DEFAULT", res.data);

                        // Verificar se o cliente tem endereços cadastrados
                        if (!res.data || !res.data.postcode) {
                            // Nenhum endereço encontrado, não faça nada
                            return;
                        }
                
                        let saveAddressDefault = {
                            "cep": res.data.postcode,
                            "logradouro": res.data.address,
                            "complemento": res.data.complement,
                            "unidade": "",
                            "bairro": res.data.district,
                            "localidade": res.data.city,
                            "uf": res.state,
                            "estado": res.city,
                            /*"regiao": "Sudeste",
                            "ibge": "3550308",
                            "gia": "1004",
                            "ddd": "11",
                            "siafi": "7107"*/
                        }           

                        sessionStorage.setItem(
                            "zipcodedefault",
                            JSON.stringify(saveAddressDefault)
                        );

                        // dispatch("product/get_free_shipping_day", saveAddressDefault, { root: true } );
    
                    })
                    .catch((error) => {
                        commit("ERROR_ADDRESS_DEFAULT", "Erro ao carregar os enderecos");
                    })
                    .finally(() => (
                        // this.loading = false
                        console.log('login request end')
                    ));
            } catch (e) {
                commit("ERROR_ADDRESS_DEFAULT", e);
            }
        },
        
    },
    mutations: {
        GET_ADDRESS(state, data) {
            state.address = data
        },
        GET_STATES(state, data) {
            state.states = data
        },
        ERROR_STATE(state, data) {
            console.log(data)
        },

        GET_CITIES(state, data) {
            state.cities = data
        },
        ERROR_CITY(state, data) {
            console.log(data)
        },

        GET_ADD_ADDRESS(state, data){
            state.add_address = data
        },
        ERROR_ADD_ADDRESS(state, data){
            console.log(data)
        },

        GET_UPT_ADDRESS(state, data) {
            state.address = data; 
        },
        ERROR_UPT_ADDRESS(state, data) {
            console.log(data);
        },

        GET_ADDRESS_STORE_NULL(state, data) {
            state.addressStoreNull = data.map(address => ({
                ...address,
                default: Boolean(address.default) // Converte aqui
              }));
        },
        ERROR_STORE_NULL(state, data) {
            console.log(data);
        },
        
        GET_ADDRESS_DEFAULT_STORE(state, data) {
            state.addressDefaultStore = data;
        },
        ERROR_DEFAULT_STORE(state, data) {
            console.log(data);
        },

        GET_ADDRESS_DEFAULT(state, data) {
            state.addressDefault = data
        },
        ERROR_ADDRESS_DEFAULT(state, data) {
            console.log(data);
        },

        GET_ADDRESS_COMPANY(state, data) {
            state.addressCompany = data
        },
        ERROR_ADDRESS_COMPANY(state, data) {
            console.log(data);
        },
    }
}